var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7819 7.99998C15.4546 7.99998 16.0095 8.54846 15.9074 9.21342C15.7308 10.3645 15.3042 11.4682 14.6518 12.4446C13.7727 13.7602 12.5233 14.7855 11.0615 15.391C9.59966 15.9965 7.99113 16.155 6.43928 15.8463C4.88743 15.5376 3.46197 14.7757 2.34315 13.6569C1.22433 12.538 0.462403 11.1126 0.153721 9.5607C-0.15496 8.00885 0.00346625 6.40032 0.608968 4.93851C1.21446 3.4767 2.23984 2.22727 3.55544 1.34822C4.53182 0.695823 5.63552 0.269176 6.78656 0.0925378C7.45152 -0.00950748 8 0.545351 8 1.2181C8 1.89085 7.44826 2.42291 6.79157 2.56904C6.12302 2.7178 5.48421 2.9895 4.90894 3.37388C3.99398 3.98524 3.28086 4.85418 2.85975 5.87082C2.43865 6.88747 2.32847 8.00615 2.54314 9.08542C2.75782 10.1647 3.28772 11.1561 4.06583 11.9342C4.84393 12.7123 5.8353 13.2422 6.91456 13.4569C7.99383 13.6715 9.11251 13.5614 10.1292 13.1402C11.1458 12.7191 12.0147 12.006 12.6261 11.0911C13.0105 10.5158 13.2822 9.87696 13.4309 9.20841C13.5771 8.55172 14.1091 7.99998 14.7819 7.99998Z",
    fill: "#2047AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.630d6515fd0918ba8c2a11f614f20c1e.svg";
export { ForwardRef as ReactComponent };